import { Button, Card, Space, Typography } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { adminApi } from "@/api/client";
import { useAuthStore } from "@/stores/authStore";

/** OpenAPI 当前无自助 TOTP  enrolment；对齐 `workers/admin-api` 运维入库流程说明。 */
export function MfaSetupPage() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const clearSession = useAuthStore((s) => s.clearSession);

  async function reloadMe() {
    await qc.invalidateQueries({ queryKey: ["admin"] });
    const me = await adminApi.GET("/admin/v1/me");
    if (me.data?.mfa_bound) {
      navigate("/dashboard", { replace: true });
    }
  }

  return (
    <div style={{ padding: 24 }}>
      <Card title={t("mfa.title")}>
        <Typography.Paragraph>{t("mfa.body")}</Typography.Paragraph>
        <Space>
          <Button type="primary" onClick={() => void reloadMe()}>
            {t("mfa.refresh")}
          </Button>
          <Button
            danger
            onClick={() => {
              clearSession();
              navigate("/login");
            }}
          >
            {t("mfa.backLogin")}
          </Button>
        </Space>
      </Card>
    </div>
  );
}
